import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { api } from "../lib/api";
import { Button } from "../components/ui/button";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";

const MAX_POLLS = 8;

export default function BazaarSuccessPage() {
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get("session_id");
  const navigate = useNavigate();
  const [status, setStatus] = useState("polling"); // polling | paid | timeout
  const [order, setOrder] = useState(null);

  useEffect(() => {
    if (!sessionId) return;
    let attempts = 0;
    const poll = async () => {
      attempts += 1;
      try {
        const { data } = await api.get(`/bazaar/orders/status/${sessionId}`);
        if (data.status === "paid") {
          setOrder(data);
          setStatus("paid");
          return;
        }
      } catch {
        // keep polling
      }
      if (attempts >= MAX_POLLS) {
        setStatus("timeout");
        return;
      }
      setTimeout(poll, 2000);
    };
    poll();
  }, [sessionId]);

  return (
    <div className="min-h-screen bg-[#151613] text-[#f1e0c5] flex items-center justify-center px-4" data-testid="bazaar-success-page">
      <div className="max-w-md w-full text-center space-y-4">
        {status === "polling" && (
          <>
            <Loader2 className="w-10 h-10 animate-spin mx-auto text-[#D4AF37]" />
            <p className="text-sm text-[#f1e0c5]/60" data-testid="bazaar-success-polling">Confirming your purchase with Stripe…</p>
          </>
        )}
        {status === "paid" && (
          <>
            <CheckCircle2 className="w-14 h-14 mx-auto text-[#3F9142]" />
            <h1 className="font-display text-3xl" data-testid="bazaar-success-title">Purchase Complete!</h1>
            <p className="text-sm text-[#f1e0c5]/60">{order.items.length} item{order.items.length === 1 ? "" : "s"} unlocked — find them under My Purchases.</p>
            <Button data-testid="bazaar-success-view-purchases" onClick={() => navigate("/bazaar")} className="rounded-full bg-[#D4AF37] text-black hover:bg-[#c19d2e]">Go to My Purchases</Button>
          </>
        )}
        {status === "timeout" && (
          <>
            <XCircle className="w-14 h-14 mx-auto text-[#D90429]" />
            <p className="text-sm text-[#f1e0c5]/60" data-testid="bazaar-success-timeout">Still waiting on Stripe to confirm — check My Purchases in a moment.</p>
            <Button data-testid="bazaar-success-back-button" onClick={() => navigate("/bazaar")} variant="secondary" className="rounded-full">Back to the Bazaar</Button>
          </>
        )}
      </div>
    </div>
  );
}
